import React, { useState, useEffect } from 'react';
import axios from 'axios';

import 'react-datepicker/dist/react-datepicker.css';

export default function CreateExercise(){

    const [username, setUsername] = useState('test user');
    const [description, setDescription] = useState('');
    const [duration, setDuration] = useState(0);
    const [date, setDate] = useState(new Date());
    const [users, setUsers] = useState([]);

    useEffect(()=> {
        axios.get('https://exercise-tracker5.herokuapp.com/users')
        .then(res => {
            res.data.length > 0 && setUsers(res.data.map((user) => user.username));
            
        })
    },[users])



    function onSubmit(e){
        e.preventDefault();

        const exercise = {
            username: username,
            description: description,
            duration: duration,
            date: date
        }
        console.log(exercise);

        axios.post('https://exercise-tracker5.herokuapp.com/exercises/add', exercise)
            .then(res => console.log(res.data))
            .catch(err => console.log(err))

        window.location = '/';
    }

    // useEffect(() => {
    //     setUsers(['test user']);
    //     setUsername('test user');
    // },[]);

    return(
        <div className="CreateExercise">
            <h2>Create an Exercise log</h2>
            <form className="exerForm">
                <select value={username} onChange={(e)=>setUsername(e.target.value)}>
                    {
                        users.map((user)=>{
                            return <option value={user}>{user}</option>
                        })
                    }
                </select>
                <div className='descriptionfield'>
                    <label>Description: </label>
                    <input type='text' value={description} onChange={(e)=>setDescription(e.target.value)} />
                </div>
                <div className='durationfield'>
                    <label>Duration: </label>
                    <input type='number' value={duration} onChange={(e)=>setDuration(e.target.value)} />
                </div>
                <div className='datefield'>
                    <label>Date:</label>
                    <input type='date' value={date} onChange={(e)=>setDate(e.target.value)} />
                </div>
                <button onClick={onSubmit}>Create Exercise Log</button>
            </form>
        </div>
    )
}
